import script from "./top.vue?vue&type=script&lang=ts&setup=true"
export * from "./top.vue?vue&type=script&lang=ts&setup=true"

import "./top.vue?vue&type=style&index=0&id=d5c3e004&lang=scss&scoped=true"

import exportComponent from "/builds/mit/fe/NEWRR/business-fe/global-os/global-retail-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c3e004"]])

export default __exports__